<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refRawMaterialsClosedGrid'
        :data-source='rawMaterialsInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="거래처코드"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="excelFileName"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumn
          :allowEditing='true'
          caption="마감처명"
          data-field="거래처코드"
          :visible='true'
        >
           <DxLookup
            :data-source="customerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn caption="원자재소요량" alignment="center">
          <DxColumn
            :allowEditing="true"
            caption="계획(Kg)"
            data-field="계획수량"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="실적(Kg)"
            data-field="실적수량"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            alignment="right"
            caption="달성율%"
            data-field="중량달성률"
            :visible='true'
            format='#0.#%'
            :calculate-cell-value="calcTotalRate"
          >
          </DxColumn>
        </DxColumn>
        <DxColumn caption="매 입 현 황 (원)" alignment="center">
          <DxColumn
            :allowEditing="true"
            caption="예상매입액"
            data-field="계획금액"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="금액점유율%"
            data-field="금액점유율"
            :visible='true'
            format='#0.#%'
            :calculate-cell-value="calcTotalPercent"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="매입실적액"
            data-field="입고금액"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            alignment="right"
            caption="매입기준%"
            data-field="금액달성률"
            :visible='true'
            format='#0.#%'
            :calculate-cell-value="calcAmountRate"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="차감금액"
            data-field="정산금액"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="계산서"
            data-field="계산서금액"
            :visible='true'
            dataType="number"
            format='#,##0'
            :calculate-cell-value="calcTaxAmount"
          >
          </DxColumn>

          <DxColumn
            :allowEditing="true"
            alignment="right"
            caption="계산서기준%"
            data-field="계산서달성률"
            :visible='true'
            format='#0.#%'
            :calculate-cell-value="calcAmountRateTax"
          >
          </DxColumn>
        </DxColumn>
        <DxSummary :calculate-custom-summary="calculateSelectedRow">
          <DxTotalItem
            summary-type="count"
            value-format='#,##0'
            column="거래처코드"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="계획수량"
            display-format="{0} Kg"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="실적수량"
            display-format="{0} Kg"
          />
          <DxTotalItem
            name="TotalRateSummary"
            summary-type="custom"
            value-format='#0.#%'
            column="중량달성률"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="계획금액"
            display-format="{0} 원"
          />
          <DxTotalItem
            value-format='#0.#%'
            summary-type="sum"
            column="금액점유율"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="입고금액"
            display-format="{0} 원"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="정산금액"
            display-format="{0} 원"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="계산서금액"
            display-format="{0} 원"
          />
          <DxTotalItem
            name="TotalAmountSummary"
            summary-type="custom"
            value-format='#0.#%'
            column="금액달성률"
            display-format="{0}"
          />
          <DxTotalItem
            name="TotalRateSummaryTax"
            summary-type="custom"
            value-format='#0.#%'
            column="계산서달성률"
            display-format="{0}"
          />
        </DxSummary>
        <DxMasterDetail
          :enabled="true"
          template="purchaseReCalc"
        />
        <template #purchaseReCalc="{ data: item }">
          <PurchaseReCalcSubGrid :item=item :baseDate="baseDate" goodsType="원자재" @refresh-recalc-amount="onRefreshRecalcAmount"
          />
        </template>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling, DxFilterRow, DxExport, DxMasterDetail,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup,
  DxSummary, DxTotalItem
} from 'devextreme-vue/data-grid'
import PurchaseReCalcSubGrid from './PurchaseReCalcSubGrid'

export default {
  name: 'rawMaterialsClosed',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '원자재 매입 마감'
        }
      ],
      excelFileName: null,
      selectedRow: null,
      rawMaterialsInfoList: null,
      materialTypeLookup: null,
      itemTypeLookup: null,
      isExpandAll: false,
      selectedRowBefore: 'init',
      baseDate: null,
      customerLookup: null,
      rawMaterialsClosedDate: null,
      rawMaterialsClosedRegDateBox: null

    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxMasterDetail,
    DxSummary,
    DxTotalItem,
    PurchaseReCalcSubGrid
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.rawMaterialsClosedDate = `${AppLib.getToday().substring(0, 7)}-01`
    this.customerLookup = this.$store.getters.getCompanyInfo
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.materialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.refreshRawMaterialsResult()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calculateSelectedRow (options) {
      if (options.name === 'TotalRateSummary') {
        if (options.summaryProcess === 'finalize') {
          let totalPlanQty = 0
          let totalInputQty = 0
          this.rawMaterialsInfoList.forEach(item => {
            totalPlanQty += item.계획수량
            totalInputQty += item.실적수량
          })
          if (totalPlanQty === 0) {
            options.totalValue = 0
          } else {
            options.totalValue = totalInputQty / totalPlanQty
          }
        }
      } else if (options.name === 'TotalRateSummaryTax') {
        if (options.summaryProcess === 'finalize') {
          let totalPlanQty = 0
          let totalTaxQty = 0
          this.rawMaterialsInfoList.forEach(item => {
            totalPlanQty += item.계획금액
            totalTaxQty += (item.입고금액 + item.정산금액)
          })
          // console.log(totalTaxQty)
          if (totalPlanQty === 0) {
            options.totalValue = 0
          } else {
            options.totalValue = totalTaxQty / totalPlanQty
          }
        }
      } else if (options.name === 'TotalAmountSummary') {
        if (options.summaryProcess === 'finalize') {
          let totalPlan = 0
          let totalInput = 0
          this.rawMaterialsInfoList.forEach(item => {
            totalPlan += item.계획금액
            totalInput += item.입고금액
          })
          if (totalPlan === 0) {
            options.totalValue = 0
          } else {
            options.totalValue = totalInput / totalPlan
          }
        }
      }
    },
    calcTaxAmount (row) {
      return row.입고금액 + row.정산금액
    },
    calcTotalRate (row) {
      if (row.계획수량 === 0) return 0
      return row.실적수량 / row.계획수량
    },
    calcTotalPercent (row) { // 금액 점유율
      let amount = 0
      this.rawMaterialsInfoList.forEach(item => {
        amount += item.계획금액
      })
      if (amount === 0) return 0
      return row.계획금액 / amount
    },
    calcAmountRate (row) { // 금액 달성률
      if (row.계획금액 === 0) return 0
      return row.입고금액 / row.계획금액
    },
    calcAmountRateTax (row) { // 금액 달성률
      if (row.계획금액 === 0) return 0
      return (row.입고금액 + row.정산금액) / row.계획금액
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준월:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.rawMaterialsClosedDate,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            displayFormat: 'yyyy-MM',
            onInitialized: (args) => {
              this.rawMaterialsClosedRegDateBox = args.component
            },
            onValueChanged: (args) => {
              this.rawMaterialsClosedDate = args.value
              this.refreshRawMaterialsResult()
            }
          }
        }
      )
    },
    async refreshRawMaterialsResult () {
      const splitDate = this.rawMaterialsClosedDate.split('-')
      this.excelFileName = `${splitDate[0]}-${splitDate[1]}월_원자재_정산`
      this.baseDate = {
        fromDate: `${this.rawMaterialsClosedDate}`,
        toDate: `${splitDate[0]}-${splitDate[1]}-${AppLib.getMonthLastDay(splitDate[0], splitDate[1])} 23:59:59`
      }

      this.$_sp.runNoEncodeFindProc('spFindAllCoilClosedByDateAndCompany', this.baseDate)
        .then((data) => {
          if (this.rawMaterialsInfoList === null) {
            setTimeout(() => {
              this.$refs.refRawMaterialsClosedGrid.instance.refresh()
            }, 400)
          }
          this.rawMaterialsInfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // Detail subcell
    onRefreshRecalcAmount (recalcAmount) {
      console.log('onRefreshRecalcAmount', recalcAmount)
      this.selectedRow.정산금액 = recalcAmount
      this.$refs.refRawMaterialsClosedGrid.instance.refresh()
    }
  }
}
</script>

<style lang="scss">

</style>
